import { getCdcData, getPcdData } from '../services/shared';

export const RECEIVE_CDC_DATA = 'RECEIVE_CDC_DATA';
export const DATA_CDC_NOT_LOADED = 0;
export const DATA_CDC_LOADING = 1;
export const DATA_CDC_LOADED = 2;
let dataCdcLoadState = DATA_CDC_NOT_LOADED;
export function fetchCdcData(dispatch) {
  if (dataCdcLoadState === DATA_CDC_NOT_LOADED) {
    dataCdcLoadState = DATA_CDC_LOADING;
    getCdcData()
      .then(data => dispatch({
        type: RECEIVE_CDC_DATA,
        data
      }))
      .then(() => dataCdcLoadState = DATA_CDC_LOADED);
  }
}

export const RECEIVE_PCD_DATA = 'RECEIVE_PCD_DATA';
export const DATA_PCD_NOT_LOADED = 0;
export const DATA_PCD_LOADING = 1;
export const DATA_PCD_LOADED = 2;
let dataPcdLoadState = DATA_PCD_NOT_LOADED;
export function fetchPcdData(dispatch) {
  if (dataPcdLoadState === DATA_PCD_NOT_LOADED) {
    dataPcdLoadState = DATA_PCD_LOADING;
    getPcdData()
      .then(data => dispatch({
        type: RECEIVE_PCD_DATA,
        data
      }))
      .then(() => dataPcdLoadState = DATA_PCD_LOADED);
  }
}

export const DISPLAY_TYPE_UPDATED = 'DISPLAY_TYPE_UPDATED';
export function updateDisplayType(dispatch, displayType) {
  dispatch({
    type: DISPLAY_TYPE_UPDATED,
    data: displayType
  });
}

export const DISPLAY_MODE_UPDATED = 'DISPLAY_MODE_UPDATED';
export function updateDisplayMode(dispatch, displayMode) {
  dispatch({
    type: DISPLAY_MODE_UPDATED,
    data: displayMode
  });
}

export const PAGE_LOAD = 'PAGE_LOAD';
export const PAGE_NOT_LOADED = 0;
export const PAGE_LOADED = 1;
export function pageLoad(dispatch) {
  dispatch({
    type: PAGE_LOAD,
    loadState: PAGE_LOADED
  });
}

export const TOGGLE_FILTERS = 'TOGGLE_FILTERS';
export function toggleFilters(dispatch) {
  dispatch({type: TOGGLE_FILTERS});
}



// WEBPACK FOOTER //
// ./src/actions/shared.js